module.exports = __webpack_public_path__ + "static/media/o_configurator_desktop.e4190932.jpg";